module.exports = __webpack_public_path__ + "static/media/scientist_lab.8eae0009.png";